import { Tutorial } from '../tutorial.model';

export const CONTADOR_TOUR: Tutorial = {
  id: 'contador',
  rota: '/painel/configuracoes/contador',
  passos: [
    { alvo: 'contador.resumo', titulo: 'Acessos do contador',
      corpo: 'Gerencie aqui os escritórios com acesso à empresa. A lista mostra os acessos ativos e os convites pendentes.' },
    { alvo: 'contador.convite', alvoAlternativo: 'contador.resumo', titulo: 'Adicionar acesso ao contador',
      corpo: 'Abra o formulário pelo botão e informe o CNPJ do escritório cadastrado. Após enviar, o convite aparece na lista. O acesso só é liberado depois do aceite.' },
    { alvo: 'contador.filtro', titulo: 'Encontre um escritório',
      corpo: 'Pesquise pelo nome ou use Filtrar para escolher a situação. Os acessos removidos ficam disponíveis em Inativos.' },
    { alvo: 'contador.revogar', alvoAlternativo: 'contador.lista', titulo: 'Remover acesso',
      corpo: 'Use a ação de remover e confirme. O convite é cancelado ou o acesso é encerrado; o escritório sai da lista padrão e o histórico é preservado.' },
  ],
};
